import { useEffect, useState } from "react";
import { useMask, format } from '@react-input/mask';
import { cadastrar, fetchMunicipios, getUserData, isLoggedIn } from "../Services/api";
// Mesmas opções do formulário de cadastro principal.
import { acompanhamentoUniversidade, fezEnem, nivelEscolaridade } from "../../../../cadastro/src/options";
import { listaCursos } from "../../../../cadastro/src/listaCursos";
import { ESTADOS_BRASILEIROS } from "../../../../cadastro/src/enums/estados";

const phoneMaskOptions = {
    mask: '(__) _ ____-____',
    replacement: { _: /\d/ },
};

export function Cadastro({ setToken }) {
    const phoneRef = useMask(phoneMaskOptions);
    const [data, setData] = useState(() => {
        const userData = getUserData();

        if (isLoggedIn() && userData) {
            return userData;
        }

        return {};
    });
    const [estado, setEstado] = useState(data.estado || "");
    const [municipios, setMunicipios] = useState<string[]>([]);

    useEffect(() => {
        if (estado) {
            fetchMunicipios(estado).then(setMunicipios);
        }
    }, [estado]);

    function handleSubmit(e) {
        e.preventDefault();

        const formData = new FormData(e.target);
        // @ts-ignore
        const data = [...formData.entries()].reduce((acc, currentItem) => {
            return {
                ...acc,
                [currentItem[0]]: currentItem[1],
            };
        }, {});

        cadastrar(data).then((result) => {
            if (result && result.token) {
                setToken(result.token);
            }
        })
    }

    return <div>
        <h3>Cadastre-se para poder calcular a sua nota do ENEM</h3>

        <form onSubmit={handleSubmit}>
            <div className="correcao-tri-form-group">
                <label htmlFor="nome">Nome</label>
                <input defaultValue={data && data.nome} type="text" name="nome" id="nome" required />
            </div>

            <div className="correcao-tri-form-group">
                <label htmlFor="email">Email</label>
                <input defaultValue={data && data.email} type="email" name="email" id="email" required />
            </div>

            <div className="correcao-tri-form-group">
                <label htmlFor="telefone">Telefone</label>
                <input ref={phoneRef} defaultValue={data && data.telefone ? format(data.telefone, phoneMaskOptions) : ""} type="text" name="telefone" id="telefone" required />
            </div>

            <div className="correcao-tri-form-group">
                <label htmlFor="estado">Estado</label>
                <select name="estado" id="estado" required value={estado} onChange={(e) => setEstado(e.target.value)}>
                    <option value="" disabled>Selecione...</option>
                    {Object.entries(ESTADOS_BRASILEIROS).map(([uf, nome]) => <option key={uf} value={uf}>{nome}</option>)}
                </select>
            </div>

            <div className="correcao-tri-form-group">
                <label htmlFor="cidade">Cidade</label>
                {/* key: remonta ao trocar de estado ou ao chegar a lista, para o defaultValue valer */}
                <select key={estado + municipios.length} name="cidade" id="cidade" required
                        defaultValue={municipios.includes(data.cidade) ? data.cidade : ""}>
                    <option value="" disabled>Selecione...</option>
                    {municipios.map((municipio) => <option key={municipio} value={municipio}>{municipio}</option>)}
                </select>
            </div>

            <div className="correcao-tri-form-group">
                <label htmlFor="data_nascimento">Data de nascimento</label>
                <input defaultValue={data && data.data_nascimento} type="date" name="data_nascimento" id="data_nascimento" required />
            </div>

            <Selecao name="nivel_escolaridade" label="Qual seu nível de escolaridade?" options={nivelEscolaridade} defaultValue={data.nivel_escolaridade} />
            <Selecao name="fez_enem" label="Você já fez o Enem?" options={fezEnem} defaultValue={data.fez_enem} />
            <Selecao name="primeira_opcao_curso" label="Qual curso você pretende estudar?" options={listaCursos} defaultValue={data.primeira_opcao_curso} />
            <Selecao name="acompanhamento_universidade" label="Você quer uma universidade te acompanhando na sua jornada?" options={acompanhamentoUniversidade} defaultValue={data.acompanhamento_universidade} />

            <div className="correcao-tri-form-group">
                <button>Enviar</button>
            </div>
        </form>
    </div>;
}

function Selecao({ name, label, options, defaultValue }: { name: string, label: string, options: string[], defaultValue?: string }) {
    return <div className="correcao-tri-form-group">
        <label htmlFor={name}>{label}</label>
        <select name={name} id={name} required defaultValue={options.includes(defaultValue) ? defaultValue : ""}>
            <option value="" disabled>Selecione...</option>
            {options.map((option) => <option key={option} value={option}>{option}</option>)}
        </select>
    </div>;
}
